<template lang="pug">
  .consultants-table
    .consultants-table__header
      .consultants-table__row.consultants-table__row--head
        .consultants-table__column {{ 'base.status' | translate }}
        .consultants-table__column {{ 'base.type' | translate }}
        .consultants-table__column {{ 'base.name' | translate }}
        .consultants-table__column {{ 'base.email' | translate }}
        .consultants-table__column {{ 'base.farms' | translate }}

    v-table-body(
      v-if="loaded"
      outside-table
      :empty="!users.length")

      consultants-table-row(
        v-for="item in users"
        :key="item.id"
        @update-table="refreshTable"
        :item="item")

    consultants-table-row-skeleton(
      v-else)
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ConsultantsTableRow from './ConsultantsTableRow'
import ConsultantsTableRowSkeleton from './ConsultantsTableRowSkeleton'

export default {
  name: 'ConsultantsTable',

  components: {
    ConsultantsTableRow,
    ConsultantsTableRowSkeleton
  },

  mounted () {
    this.loadData()
  },
  props: {
    role: {
      type: String,
      default: 'consultant'
    }
  },
  data: () => ({
    loaded: false
  }),

  computed: {
    ...mapGetters('dashboard', [
      'users',
      'countUsers'
    ])
  },

  methods: {
    ...mapActions('dashboard', [
      'loadUsers'
    ]),
    refreshTable () {
      this.loadData()
    },

    async loadData () {
      const params = {
        user_type: this.role
      }
      await this.loadUsers(params)
      this.loaded = true
    }
  },
  watch: {
    role (newVal, oldVal) {
      this.loadData()
    }
  }
}
</script>

<style lang="scss">
  @import '@/sass/abstracts/_variables.scss';

  .consultants-table {
    font-size: 1.5rem;
    line-height: 1.8rem;

    &__row {
      position: relative;
      padding: 1.2rem 2rem;
      display: flex;
      align-items: center;

      &--header {
        padding: 1.5rem 2rem;

        .consultants-table {
          &__column {
            color: $color-gray;
          }
        }
      }
    }

    &__header {
      margin: 1.5rem 0;
      background-color: var(--color-surface);
    }

    &__column {
      display: flex;
      align-items: center;
      padding-right: 1rem;
      width: 20%;
    }

    &__status {
      display: inline-flex;
      position: relative;
      padding-left: 2rem;

      &::before {
        content: '';
        position: absolute;
        display: block;
        width: 1.2rem;
        height: 1.2rem;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        border-radius: 50%;
        background-color: $color-primary;
      }

      &--locked {
        color: $color-red;

        &::before {
          background-color: $color-red;
        }
      }
    }

    &__settings {
      position: absolute;
      right: .5rem;
    }
  }
</style>
